import { isSupported, subscribe } from 'on-screen-keyboard-detector';
import React from 'react';
import { UAParser } from 'ua-parser-js';

type State = 'visible' | 'hidden' | 'not supported';

export function useOnScreenKeyboardDetector() {
  const currentSubscription = React.useRef<() => void>(() => 0);
  const [state, setState] = React.useState<State>('not supported');
  React.useEffect(() => {
    const parser = new UAParser();
    const isAndroid = parser.getOS().name === 'Android';
    if (isSupported() && isAndroid) {
      if (currentSubscription.current) {
        currentSubscription.current();
      }
      currentSubscription.current = subscribe((visibility) => {
        if (visibility === 'hidden') {
          setState('hidden');
        } else {
          setState('visible');
        }
      });
    }
    return () => {
      if (currentSubscription.current) {
        currentSubscription.current();
      }
    };
  }, []);
  return state;
}
